/**
 * 貼文 / 世界觀內容中的 hashtag 處理。
 * 慣例：內容中的 #tag 於送出時抽出另傳 tags[]，content 只保留剝除 tags 後的純文字；
 * 編輯時再用 tagsToText 把既有 tags 還原回內容供使用者增刪。
 */
const TAG_REGEX = /#[^\s#]+/g;

/**
 * 抽出內容中的 tags（不含 # 前綴）。
 *
 * @param {string} text
 * @returns {string[]}
 */
export const extractTags = (text) => {
  const matches = text.match(TAG_REGEX);
  return matches ? matches.map((tag) => tag.substring(1)) : [];
};

/**
 * 移除內容中的 tags。
 *
 * @param {string} text
 * @returns {string}
 */
export const stripTags = (text) => text.replace(TAG_REGEX, '');

/**
 * 將 API 回傳的 tags 陣列還原為 #tag 文字，供編輯時接回內容尾端。
 *
 * @param {Array<{tag_id: number, tag_name: string}>} tags
 * @returns {string}
 */
export const tagsToText = (tags) => tags.map((tag) => `#${tag.tag_name}`).join(' ');
